import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { findDOMNode } from 'react-dom';
import axios from 'axios';

import OptionsHelper from '../../lib/OptionsHelper';
import JsonValidator from '../..//lib/JsonValidator';
import { franchiseList } from '../../store/actions/franchise';
import { reportLogReport } from '../../store/actions/report';

import Spinner from '../../components/Spinner/Spinner';
import PageHeader from '../../components/PageHeader/PageHeader';
import FormInput from '../FormInput/FormInput';
import CancelButton from '../Buttons/CancelButton/CancelButton';
import { Button } from 'react-bootstrap';

import Multiselect from 'multiselect-react-dropdown';
import InputCollection from '../../components/InputCollection/InputCollection';
import { modifyToInstance } from '../../lib/Formatter';

class Report extends Component {
  state = {
        isLoaded: false,
        isDisabled: true,
        reportName: '',
        reportParameters: null,
        reportStart: Date.now(),
        defaultRequest: 'true'
    };

    constructor(props) {
        super(props);
        this.franchiseDropdown = React.createRef();
    }

    componentDidMount() {
        if (!this.props.franchiseList) { this.props.onFranchiseList(); }
        if (!this.props.userName){
          const authObject = localStorage.getItem('authData');
          let valid = (authObject && JsonValidator(authObject)); 
          if (valid) {
            const authData = JSON.parse(authObject);
            this.userName = authData['username'];
          }
        }
    };

    renderingComplete5(args, reactself) {
        if (!_.isEmpty(args) && !_.isEmpty(args.reportParameters) && !_.isUndefined(args.reportParameters))
        {
            window.jQuery('.e-reportviewer-viewer .e-reportviewer-viewerblock').css('height', '1px');
            window.jQuery('.e-chk-act').hide();
            window.jQuery('.e-spanicon').hide();

            reactself.setState({ reportParameters:args.reportParameters })
        }

        var logObject =
        {
            data: {
                ReportPath: reactself.props.report.syncFusionLocation,
                ReportServer: 'reports.homesmartbeta.com',
                Parameters: !_.isEmpty(reactself.state.reportParameters) && !_.isUndefined(reactself.state.reportParameters)
                    ? Object.values(reactself.state.reportParameters).map(v => [v.Prompt,v.Value])
                    : null,
                CurrentUser: reactself.userName,
                StartOrEnd: 'End',
                StartEpoc: reactself.state.reportStart,
                EndEpoc: Date.now(),
                DefaultRequest: reactself.state.defaultRequest
            }
        };

        reactself.props.onReportLogReport(logObject);
        reactself.setState({ isDisabled: false });
    }

    componentDidUpdate(prevProps) {
        if (this.props.lastState !== prevProps.lastState) {
            if (this.props.report !== null && this.props.report !== "") {
                if (!this.state.isLoaded) {
                    let instance = axios.create({
                        baseURL: 'https://reports.homesmartbeta.com/api'
                    });
                    let reportLocation = this.props.report.syncFusionLocation;
                    this.setState({ reportName: this.props.report.name });

                    instance.post('/get-user-key', { userid: 'coreapi', password: '8vj28fk9!D93ks41' }).then((response) => {
                        const token = JSON.parse(response.data.Token);
                        const el = findDOMNode(this.refs.container);
                
                        const reactself = this;
                        
                        window.jQuery(el).ejReportViewer({
                        reportServiceUrl: 'https://reports.homesmartbeta.com/ReportService/api/Viewer',
                        serviceAuthorizationToken: token.token_type + ' ' + token.access_token,
                        reportPath: reportLocation,
                        // THIS IS A HACK TO ALLOW THE ARGS TO BE PASSED BACK TO THE REACT CLASS
                        renderingComplete: function(args) {
                            reactself.renderingComplete5(args,reactself);
                            }
                        });
                    });
                
                    this.setState({ isLoaded: true });
                }
            }
        }
    };

    changedHandler = (id, value) => {
        let params = this.state.reportParameters;
        let i = 0;
        let eleType = null;
        while (params[i] !== undefined && params[i] !== null) {
            if (params[i].Name === id) {
                params[i].Value = value;
                eleType = params[i].ParameterElementType;
            }

            i++;
        };
        this.setState({isDisabled: false});

        if (eleType !== "MultiValue" || this.state.reportParameters !== params) {
            this.setState({reportParameters: params});
        }
    };

    inputChangedHandler = (event) => {
        let id = '';
        let value = null;

        id = event.element.id;
        value = event.value;

        this.changedHandler(id, value);
    };

    selectHandler = (list, name, _item) => {        
        let records = [];
        let reportValues = [];
        
        if (!_.isEmpty(list)) {
            list.forEach((record) => {
                records.push(record);
                reportValues.push(record.id.toString());
            });                        
        }
        this.setState({isDisabled: false});
        this.setState({ [name]: records });

        let reportParams = this.state.reportParameters;
        let n = 0;
        while(reportParams[n] && reportParams[n].Name !== undefined){
            if (reportParams[n] && reportParams[n].Name !== undefined && reportParams[n].Name == name) {
                reportParams[n].Value = reportValues;
                this.setState({ reportParameters: reportParams });
            }
            n++;
        }
    };

    removeHandler = (list, name, _item) => {        
        let records = [];
        let reportValues = [];

        if (!_.isEmpty(list)) {
            list.forEach((record) => {
                records.push(record);
                reportValues.push(record.id.toString());
            }); 
        }
        this.setState({ [name]: records });

        let reportParams = this.state.reportParameters;
        let n = 0;
        while(reportParams[n] && reportParams[n].Name !== undefined){
            if (reportParams[n] && reportParams[n].Name !== undefined && reportParams[n].Name == name) {
                reportParams[n].Value = reportValues;
                this.setState({ reportParameters: reportParams });
            }
            n++;
        }
    };

    cancelledHandler = () => {
        if (this.props.cancelled) { this.props.cancelled(); }
    };

    getCheckbox = (item, val) => {
        let setval = false;

        if (val === "null" || val === "" || val === null) {
            setval = true;
        }

        let n = window.jQuery(':checkbox');
        let cb = null;
        
        for (let i = 0; i < n.length; i++) {
            if (n[i].id === item.ControlId + "~chk") { cb = n[i]; }
        }

        if (cb !== null) {
            window.jQuery('.e-chk-act').show();
            window.jQuery('.e-chk-inact').show();
            if (cb.checked !== setval) { cb.click(); }
            window.jQuery('.e-chk-inact').hide();
            window.jQuery('.e-chk-act').hide();
        }
    }

    runReport = () => {
        let params = this.state.reportParameters;
        let i = 0;

        while (params[i] !== undefined && params[i] !== null) {
            if (params[i].ParameterElementType === "Textbox") {
                if (params[i].IsNullable) {
                    this.getCheckbox(params[i], window.jQuery("#" + params[i].Name).val());
                }
                window.jQuery("#" + params[i].ControlId).val(params[i].Value);
            } else if (params[i].ParameterElementType === "ComboBox") {
                if (params[i].IsNullable) {
                    this.getCheckbox(params[i], window.jQuery("#" + params[i].Name).val());
                }
                window.jQuery("#" + params[i].ControlId).data('ejDropDownList').uncheckAll();
                window.jQuery("#" + params[i].ControlId).data('ejDropDownList').selectItemByValue(params[i].Value);
            } else if (params[i].ParameterElementType === "MultiValue") {
                if (params[i].IsNullable) {
                    this.getCheckbox(params[i], window.jQuery("#" + params[i].Name).val());
                }
                window.jQuery("#" + params[i].ControlId).data('ejDropDownList').uncheckAll();
                window.jQuery("#" + params[i].ControlId).data('ejDropDownList').selectItemByValue(params[i].Value);
            } else if (params[i].ParameterElementType === "DateTime") {
                if (params[i].IsNullable) {
                    this.getCheckbox(params[i], window.jQuery("#" + params[i].Name).val());
                }
                let dval = new Date(params[i].Value);
                dval.setDate(dval.getDate() + 1);
                window.jQuery("#" + params[i].ControlId).ejDatePicker('instance').option('value', dval);
            } else if (params[i].ParameterElementType === "RadioButton") {
                // if (params[i].IsNullable) {
                     this.getCheckbox(params[i], window.jQuery("#" + params[i].Name).checked);
                // }
                if (params[i].Value === true || params[i].Value === "true" || params[i].Value === "True" || params[i].Value === 1) {
                    window.jQuery("#" + params[i].ControlId + "_01").click();
                } else {
                    window.jQuery("#" + params[i].ControlId + "_02").click();
                }
            }

            i++;
        }

        this.setState({ isDisabled: true, defaultRequest: 'false' }, () => {
            window.jQuery("#container_viewReportClick").click();
        });        
      };

    allInputs = () => {
        let params = this.state.reportParameters;

        if (typeof(params) === "object" && params !== null) {
            let toReturn = [];
            let i = 0;

            while(params[i]!==undefined){
                if (params[i].ParameterElementType === "ComboBox"){
                    toReturn = toReturn.concat(this.selectInput(params[i]));
                }

                if (params[i].ParameterElementType === "MultiValue"){
                    toReturn = toReturn.concat(this.multiselectInput(params[i]));
                }

                if (params[i].ParameterElementType === "DateTime"){
                    toReturn = toReturn.concat(this.datePickerInput(params[i]));
                }

                if (params[i].ParameterElementType === "Textbox"){
                    toReturn = toReturn.concat(this.textBoxInput(params[i]));
                }

                if (params[i].ParameterElementType === "RadioButton"){
                    toReturn = toReturn.concat(this.checkBoxInput(params[i]));
                }

                i++;
            }

            return toReturn;
        }

        return null;
    }

    datePickerInput = (param) =>{
        let defaultValue = '';
        let paramValue = null;

        if (param.Value !== ""){
            paramValue = new Date(param.Value).toISOString().slice(0, 10);
            param.Value = paramValue;
        }

        return (   
            <div className="col-md-2" key = {param.Name}>  
                <FormInput id= {param.Name}
                    labelText={param.Prompt}
                    type="date"
                    value={paramValue || defaultValue}
                    maxLength={10}
                    changed={(id, value) => this.changedHandler(id, value)} />
            </div>
        );  
    };

    selectInput = (param) => {
        let defaultValue = '';
        let stateOptionsList = [];

        stateOptionsList = param.AvailableValues.map((x,i) => {
            let keyVal = {}
            keyVal["id"]=x;
            keyVal["name"]=param.AvailableLabels[i];
            return keyVal;
        });

        const stateOptions = OptionsHelper({ list: stateOptionsList, includeBlank: true, keyField: 'id' });

        return (
            <div className="col-md-2" key={param.Name}>
                <FormInput id={param.Name}
                    type="select"
                    labelText={param.Prompt}
                    value={param.Value || defaultValue}
                    changed={(id, value) => this.changedHandler(id, value)}>
                    {stateOptions}
                </FormInput>
            </div>
        );    
    }
    
    multiselectInput = (param) => {
        let stateOptionsList = [];

        this.availableLabelList = param.AvailableLabels;
        
        if (param.Value !== undefined && !Array.isArray(param.Value) && !_.isEmpty(param.Value)) {
            param.Value = [param.Value];
        }

        let franchisebuttons = (<div></div>);

        stateOptionsList = param.AvailableValues.map(this.multiselectMap, this);

        if(this.props.franchises && (param.Name == "Franchise" || param.Name == "Franchises" || param.Name == "FranchiseId")){
            franchisebuttons = (
                <div style={{marginBottom: '1rem'}}>
                    <Button type="button" bsStyle="default" className="button-small-gray button-group-margin btn btn-danger"onClick={(e) => this.franchiseGroupSelect(e)}>Select All</Button>
                    <Button type="button" bsStyle="default" className="button-small-gray button-group-margin btn btn-danger"onClick={(e) => this.franchiseGroupSelect(e)}>Corporate</Button>
                    <Button type="button" bsStyle="default" className="button-small-gray button-group-margin btn btn-danger"onClick={(e) => this.franchiseGroupSelect(e)}>Non-Corporate</Button>
                    <Button type="button" bsStyle="default" className="button-small-gray button-group-margin btn btn-danger"onClick={(e) => this.franchiseGroupSelect(e)}>Corporate no SRN</Button>
                </div>
            );
        }

        return (
            <div className="col-md-3" key={param.Name}>
                <InputCollection labelText={modifyToInstance(param.Prompt)}>
                    <Multiselect id={param.Name} options={stateOptionsList} avoidHighlightFirstOption={true} displayValue="name"  placeholder={'Select ' + modifyToInstance(param.Name) + '...'} emptyRecordMsg="No Records Available" selectedValues={this.state[param.Name]} ref={this.franchiseDropdown} onSelect={(list, item) => this.selectHandler(list, param.Name, item)} onRemove={(list, item) => this.removeHandler(list, param.Name, item)} />
                </InputCollection>
                {franchisebuttons}
            </div>
        );
    }

    multiselectMap = (x,i) => {
        let keyVal = {};
        keyVal["id"]=x;
        keyVal["name"]=this.availableLabelList[i];
        
        let lookupval = (this.props.franchises===null) ? undefined : this.props.franchises.filter(function(value,index,arr){return value.id.toString() === x })

        keyVal["groupby"]=(lookupval===undefined || lookupval[0]===undefined)?'Unknown':lookupval[0].corporateOwned===true?'Corporate Owned':'Non-Corporate Owned';

        return keyVal;
    }

    franchiseGroupSelect = (e, t) => {
        let reportParams = this.state.reportParameters;
        let n = 0;

        while(reportParams[n].Name !== undefined && (reportParams[n].Name !== "Franchise" && reportParams[n].Name !== "Franchises" && reportParams[n].Name !== "FranchiseId")){n++;}
        
        if (reportParams[n].Name !== undefined) {
            if (e.currentTarget.innerHTML === "Select All") {
                let filterTo = this.props.franchises.map((x,i,arr) => {
                    return {id: x.id, name: x.instance + ' - ' + x.name};
                });
                let filterToReport = this.props.franchises.map((x,i,arr) => {
                    return x.id.toString();
                });
                this.setState({ [reportParams[n].Name]: filterTo });
                reportParams[n].Value = filterToReport;
                this.setState({ isDisabled: false });
                this.setState({ reportParameters: reportParams });
            } else  if (e.currentTarget.innerHTML === "Corporate") {
                let filterTo = this.props.franchises.map((x,i,arr) => {
                    return x.corporateOwned&&reportParams[n].AvailableValues.includes(x.id.toString())?{id: x.id, name: x.instance + ' - ' + x.name}:"-1";
                });
                filterTo = filterTo.filter(function(value,index,arr){return value !== "-1" });
                let filterToReport = this.props.franchises.map((x,i,arr) => {
                    return x.corporateOwned&&reportParams[n].AvailableValues.includes(x.id.toString())? x.id.toString() :"-1";
                });
                filterToReport = filterToReport.filter(function(value,index,arr){return value !== "-1" });
                this.setState({ [reportParams[n].Name]: filterTo });
                reportParams[n].Value = filterToReport;
                this.setState({ isDisabled: false });
                this.setState({ reportParameters: reportParams });
            } else if(e.currentTarget.innerHTML === "Non-Corporate") {
                let filterTo = this.props.franchises.map((x,i,arr) => {
                    return !x.corporateOwned&&reportParams[n].AvailableValues.includes(x.id.toString())?{id: x.id, name: x.instance + ' - ' + x.name}:"-1";
                });
                filterTo = filterTo.filter(function(value,index,arr){return value !== "-1" });
                let filterToReport = this.props.franchises.map((x,i,arr) => {
                    return !x.corporateOwned&&reportParams[n].AvailableValues.includes(x.id.toString())? x.id.toString() :"-1";
                });
                filterToReport = filterToReport.filter(function(value,index,arr){return value !== "-1" });                
                this.setState({ [reportParams[n].Name]: filterTo });
                reportParams[n].Value = filterToReport;
                this.setState({ isDisabled: false });
                this.setState({ reportParameters: reportParams });
            } else if(e.currentTarget.innerHTML === "Corporate no SRN") {
                let filterTo = this.props.franchises.map((x,i,arr) => {
                    return x.corporateOwned&&reportParams[n].AvailableValues.includes(x.id.toString())&&x.instance!=='HS0041'?{id: x.id, name: x.instance + ' - ' + x.name}:"-1";
                });
                filterTo = filterTo.filter(function(value,index,arr){return value !== "-1" });
                let filterToReport = this.props.franchises.map((x,i,arr) => {
                    return x.corporateOwned&&reportParams[n].AvailableValues.includes(x.id.toString())&&x.instance!=='HS0041'? x.id.toString():"-1";
                });   
                filterToReport = filterToReport.filter(function(value,index,arr){return value !== "-1" });
                this.setState({ [reportParams[n].Name]: filterTo });
                reportParams[n].Value = filterToReport;
                this.setState({ isDisabled: false });
                this.setState({ reportParameters: reportParams });
            }
        }
    }

    textBoxInput = (param) => {
        return ( 
            <div className="col-md-2" key = {param.Name}>  
                <FormInput id={param.Name}
                    labelText={param.Prompt}
                    type="text"
                    autoComplete="off"
                    value={param.Value || ''}
                    changed={(id, value) => this.changedHandler(id, value)}
                    />
            </div>
        );
    }

    checkBoxInput = (param) => {
        let paramVal = (param.Value === "True" || param.Value === "true" || param.Value === true || param.Value === 1) ? true : false;
        return (  
            <div className="col-md-2" key = {param.Name}>  
            <div style={{ height: '27px'}}>&nbsp;</div>
                <FormInput type="checkbox" 
                    id={param.Name}
                    value={paramVal}
                    labelText={param.Prompt}
                    changed={(id, value) => this.changedHandler(id, value)}
                    />
            </div>
        );        
    };

    render() {
        let internalContent = this.allInputs();
        const disabledClass = (this.state.isDisabled) ? "button-group-margin btn btn-danger disabled" : "button-group-margin btn btn-danger";

        return (
            <>
                <PageHeader title={(this.state.reportName) ? modifyToInstance(this.state.reportName) : ''} />
                {
                    !this.state.isLoaded && <Spinner text="Loading Report..." />
                }
                {
                    this.state.isLoaded && (
                        <>
                            <div className="row">
                                {internalContent}
                                <div className="col-md-2">
                                    <div style={{ height: '25px'}}>&nbsp;</div>
                                    <Button type="button" bsStyle="default" className={disabledClass} onClick={this.runReport} disabled={this.state.isDisabled}>Run Report</Button>
                                </div>
                            </div>
                            <div style={{ display: 'flex', position: 'absolute', top: '125px', right: '35px'}}>
                                <CancelButton text='Back'  clicked={this.cancelledHandler} />
                            </div>
                            <div style={{ display: 'flex', position: 'relative', height: 'calc(100vh - 250px)' }}>
                                <div id="container" ref="container"></div>
                            </div>
                        </>
                    )
                }                
            </>
        );
    };
};

const mapStateToProps = (state) => ({
    error: state.error,
    report: state.report.report,
    franchises: state.franchise.franchises,
    franchisesState: state.franchise.lastState,
    lastState: state.report.lastState,
    lastScope: state.report.lastScope
});

const mapDispatchToProps = (dispatch) => ({
  onFranchiseList: () => dispatch(franchiseList()),
  onReportLogReport: (options) => dispatch(reportLogReport(options))
});

export default connect(mapStateToProps, mapDispatchToProps)(Report);
